import { ParallaxBackground } from "@/ui/ParallaxBackground";
import { Tagline } from "@/ui/Tagline";
import cn from "classnames";
import { Container, ListGroup } from "react-bootstrap";

import bg_1 from "./bg_1.webp";
import bg_2 from "./bg_2.webp";
import classes from "./styles.module.scss";

export default function ({
  className = "py-5 py-md-6",
  tagline,
  title,
  titleClassName = "text-dark",
  description,
  items,
  bg = false,
  EditableText,
  EditableHtml,
  theme = "light",
}) {
  return (
    <div className={cn(className, classes.ContentList)} data-bs-theme={theme}>
      {bg && (
        <>
          <ParallaxBackground anim="y1:x0:z0" image={bg_1} className={classes.bg_1} />
          <ParallaxBackground anim="y1:x2:z0" image={bg_2} className={classes.bg_2} />
        </>
      )}
      <Container fluid="md">
        <Tagline as={EditableText} path="tagline" tag="strong" className="d-block mb-3">
          <span dangerouslySetInnerHTML={{ __html: tagline }} />
        </Tagline>
        <EditableText path="title" tag="h2">
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </EditableText>
        <EditableHtml path="description" className="d-block mb-3">
          <div dangerouslySetInnerHTML={{ __html: description }} />
        </EditableHtml>
        <ListGroup>
          {items.map((item, idx) => (
            <ListGroup.Item key={idx}>
              <EditableText tag="h4" className={titleClassName} path={`item_${idx}_title`}>
                {item.title}
              </EditableText>
              <EditableText path={`item_${idx}_content`}>
                <div dangerouslySetInnerHTML={{ __html: item.content }} />
              </EditableText>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Container>
    </div>
  );
}
